import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getObjectTypeAvailableColumns } from './api';

export const path = '/object-type/list';

const PageObjectTypeList: React.FC = (props) => {
  const ObjectTypeList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getObjectTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ObjectTypeList {...props} />;
};

export default PageObjectTypeList;
